var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"margin-top-20"},[_c('CustomerDetailsForm',{key:_vm.companiesIdentityDetailsReloadKey,attrs:{"customerType":"potentialCustomer"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }